export const reviews = [
  {
    id: 'solvi',
    name: 'Sølvi R. Haugland',
    date: '25/05/2025',
    rating: 5,
    reviewTitle: {
      no: '+ Lokale bedrifter',
      dk: '+ Lokale virksomheder',
      sv: '+ Lokala företag',
    },
    text: {
      no: 'Supert at appen utvikler seg. Og superbra at man nå kan finne bedrifter i nabolaget! Det er bare superkjekt for både brukere og de som driver smått (og stort). Jo bedre appen blir, jo flere vil bruke den. 😍',
      dk: 'Fantastisk at appen udvikler sig. Og superlækkert at man nu kan finde virksomheder i nabolaget! Det er bare super sjovt for både brugere og dem der driver en lille (og stor) virksomhed. Jo bedre appen bliver, jo flere vil bruge den. 😍',
      sv: 'Fantastiskt att appen utvecklas. Och superbra att man nu kan hitta företag i grannskapet! Det är bara jättekul för både användare och de som driver små (och stora) företag. Ju bättre appen blir, desto fler kommer att använda den. 😍',
    },
  },
  {
    id: 'moplemaisen',
    name: 'Moplemaisen',
    date: '04/06/2025',
    rating: 5,
    reviewTitle: {
      no: 'Moplemaisen',
      dk: 'Moplemaisen',
      sv: 'Moplemaisen',
    },
    text: {
      no: 'Fin plattform som oppdateres i hurtig tempo. Dette blir bra!',
      dk: 'Fin platform der opdateres i et hurtigt tempo. Det bliver godt!',
      sv: 'Fin plattform som uppdateras i snabb takt. Det här kommer att bli bra!',
    },
  },
  {
    id: 'rune',
    name: 'Rune J. Svendsen',
    date: '28/12/2024',
    rating: 5,
    reviewTitle: {
      no: 'Endelig en sosial plattform med bra personvern',
      dk: 'Endelig en social platform med godt privatliv',
      sv: 'Äntligen en social plattform med bra integritet',
    },
    text: {
      no: 'Liker at det ikke er noen annonser og ingen algoritmer på plattformen. Samt et bra fokus på ditt nærmeste nabolag. Så kan man jo bruke dette som en mulighet til å bli bedre kjent. Spennende tanke',
      dk: 'Jeg kan godt lide, at der ikke er nogen reklamer og ingen algoritmer på platformen. Samt et godt fokus på dit nærmeste nabolag. Så kan man bruge det som en mulighed for at blive bedre kendt. Spændende tanke',
      sv: 'Jag gillar att det inte finns några annonser och inga algoritmer på plattformen. Samt ett bra fokus på ditt närmaste grannskap. Man kan använda det som en möjlighet att lära känna folk bättre. Spännande tanke.',
    },
  },
  {
    id: 'facebook-alternative',
    name: 'Torstein H. Vik',
    date: '15/03/2025',
    rating: 5,
    reviewTitle: {
      no: 'Det beste alternativet til Facebook',
      dk: 'Det bedste alternativ til Facebook',
      sv: 'Det bästa alternativet till Facebook',
    },
    text: {
      no: 'Hvis du også er lei av Facebook og deres falske profiler og reklamer, er dette klart det beste alternativet. Gi det litt tid og hjelp med å bygge opp grupper. Da skal det nok bli bra.',
      dk: 'Hvis du også er træt af Facebook og deres fup og svindel profiler og reklamer. Så er det klar det bedste alternativ . Giv det lidt tid og hjælp med at bygge grupper op. Så skal det nok blive godt',
      sv: 'Om du också är trött på Facebook och deras bluffprofiler och reklam är det här klart det bästa alternativet. Ge det lite tid och hjälp till att bygga upp grupper. Det kommer säkert att bli bra.',
    },
  },
  {
    id: 'believe',
    name: 'Kjell A. Nilsen',
    date: '22/07/2025',
    rating: 5,
    reviewTitle: {
      no: 'Har virkelig trua!',
      dk: 'Jeg har virkelig troen!',
      sv: 'Jag tror verkligen på det här!',
    },
    text: {
      no: 'Har virkelig trua! 💪 Flott og oversiktlig app med kjempenspotensial!',
      dk: 'Jeg har virkelig troen! 💪 Flot og overskuelig app med kæmpe potentiale!',
      sv: 'Jag tror verkligen på det här! 💪 Fantastisk och överskådlig app med enorm potential!',
    },
  },
];
